// Load an image in cache using its url
export function preloadImage(url) {
    return new Promise((resolve, reject) => {
        // If the url is empty
        if (!url || typeof url !== 'string' || url.trim() === '') {
            return reject(new Error('Image URL is empty or invalid'));
        }

        // Create and setup the image
        const img = new Image();
        img.src = url;

        img.onload = () => resolve();
        img.onerror = () =>
            reject(new Error(`Failed to load image url: ${url}`));
    });
}
